import { getPlayerRating } from "../functions/players"

const marketValue = (player, gameYears) => {
  let yearsRemaining = player.contractExpiry ? player.contractExpiry : 1;
  let yearModifier = 1 + (gameYears * 0.2)
  return getPlayerRating(player) * player.form * yearsRemaining * yearModifier
}
export default marketValue
